import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService, FilterMetadata } from 'primeng/api';
import { concat, merge, of, from, Subscription, Observable, Subject } from 'rxjs';
import { filter, map, switchMap, debounceTime, distinctUntilChanged, concatAll, concatMap, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService, MenuItem } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { Product, ProductListFetchParams } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'
import { Client, CustomerCategory } from 'src/app/shared/client';
import { Department } from 'src/app/shared/department';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService, StockResult } from 'src/app/services/product-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';

interface ProdStockList {
  productId: number;
  companyId: number;
  stockId: number;

  childCompanyId: number;
  childStockId: number;

  childCompanyName: string;
  childStockName: string;

  stockValue: number;
  localStockValue: number;

  gsReady: boolean;
  gsAlarm: boolean;

  lsReady: boolean;
  lsAlarm: boolean;
};

@Component({
  selector: 'app-product-list-stocks',
  templateUrl: './product-list-stocks.component.html',
  styleUrls: ['./product-list-stocks.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductListStocksComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  @Input() prodId: number /*= 58644*/;

  rows: number = 20;   /* for flex scroll */
  totalRecords: number;
  loading: boolean = false;

  _productQuery: Subscription;
  _prodListQuery: Subscription;

  product: Product;

  prodStockList: ProdStockList[] = [];

  childCompanies: Client[] = [];
  stockList: Department[] = [];
  childStockList: Department[] = [];

  search$: Observable<string>;
  private listOptions$ = new Subject<number>();

  private prodList$ = new Subject<Product[]>();

  public get paginator(): boolean { return this.prodStockList.length > 10; }

  constructor(
    private prodApi: ProductApiService,
    private cliApi: ClientApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductListComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'prodId':
          /*
           * TODO: check the groupId for new product and update information if differs
           */
          this.listOptions$.next(change.currentValue);
          break;

      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProductListComponent in ngOnDestroy')

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodListQuery) { this._prodListQuery.unsubscribe(); }

  }

  createProductSubscription() {

    this._prodListQuery =
      this.prodList$.pipe(
        switchMap(list => {
          let rd: Date = new Date();

          return from(list)
            .pipe(map((pr: Product) => {

            }));
        })
      ).subscribe();

    this._productQuery =

      this.listOptions$.pipe(
        debounceTime(200),
        switchMap(options => {

          console.log('*** ProductListComponent in createProductSubscription: pgn=(' + options + ')');
          this.loading = true;

          return of(options);
        }),

        concatMap(options => this.cliApi.getClientById(this.globalSettinsData.mainCompanyId)),
        filter(comp => comp.length > 0),
        concatMap(comp => from(comp)),
        concatMap(comp => this.cliApi.getDepartmentsByClientId(comp.CLIID).pipe(
          concatMap(deps => {
            this.stockList = deps;

            this.prodStockList = deps.map(d => ({
              productId: this.prodId,
              companyId: comp.CLIID,
              stockId: d.CLIID,
              stockValue: 0,
              localStockValue: 0,
              childCompanyId: this.globalSettinsData.mainCompanyId,
              childStockId: d.CLIID,
              childCompanyName: comp.CLIENTSNIKNAME,
              childStockName: d.CLIENTSNIKNAME,

              gsReady: false,
              gsAlarm: false,
              lsReady: false,
              lsAlarm: false,

            }));
            //environment.production || console.table(this.prodStockList);
            return from(this.prodStockList);
          }),
          concatMap(list => this.prodApi.getProductStockBefore(list.productId, list.companyId, list.stockId, new Date())
            .pipe(concatMap(stock => {
              //environment.production || console.table(stock);
              list.stockValue = (stock as StockResult[])[0]?.stock ?? 0;
              return of(list);
            }))),

          concatMap(list => this.prodApi.getProductLcStockBefore(list.productId, list.companyId, list.stockId, list.childCompanyId, new Date()).pipe(concatMap(stock => {
              //environment.production || console.table(stock);
            list.localStockValue = (stock as StockResult[])[0]?.stock ?? 0;
              return of(list);
            }))),

          concatMap(list => this.cliApi.getCliChildList(list.companyId).pipe(

            concatMap(lcos => from(lcos)),

            concatMap(lco => {
//              environment.production || console.table(lco);

              var le: ProdStockList = {
                ...list,
                stockValue: 0,
                localStockValue: 0,
                childCompanyId: lco.CLIID,
                childCompanyName: lco.CLIENTSNIKNAME,
              };

              return of(le);
            }),

            concatMap(list => this.cliApi.getChildDepartmentsById(list.childStockId, list.childCompanyId).pipe(
              filter(a => (a.length > 0)),
              concatMap(a => {
                list.childStockId = a[0].CLIID;
                list.childStockName = a[0].CLIENTSNIKNAME;

                return of(list);
              }))),

            concatMap(list => this.prodApi.getProductLcStockBefore(list.productId, list.companyId, list.stockId, list.childCompanyId, new Date()).pipe(concatMap(stock => {
              //environment.production || console.table(stock);
              list.localStockValue = (stock as StockResult[])[0]?.stock ?? 0;

              this.prodStockList.push(list);

              return of(list);
            }))),

          )),

          finalize(() => {
            //environment.production || console.table(this.prodStockList);
            this.prodStockList = [... this.prodStockList.filter(p => (p.stockValue != 0) || (p.localStockValue != 0))];

            this.prodStockList.forEach(p => {

              p.lsAlarm = p.localStockValue < 0;
              p.lsReady = p.localStockValue > 0;

              p.gsAlarm = p.stockValue < 0;
              p.gsReady = p.stockValue > 0;
             
            });
            this.loading = false;
            this.messageService.add({ severity: 'info', summary: 'Остатки по всем складам сформированы...'});

            //environment.production || console.table(this.prodStockList);
          }))),

    ).subscribe();
  }

  ngOnInit(): void {
    console.log('*** ProductListComponent in ngOnInit');

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.createProductSubscription();

    this.listOptions$.next(this.prodId);
  }
}
